import { useRSStore } from '../store/useRSStore'
import { readFwtypeListAPI ,addFwtypeAPI, updateFwtypeAPI, deleteFwtypeAPI, paginationFwtypeAPI} from '../api/FwtypeAPI'

import type { fwtype, pagination } from '../types/types'


export function useFwtype() {
  const RSStore = useRSStore()
  const onReadFwtypeList = async (pagenation: pagination) => {
    try {
      const list = await readFwtypeListAPI(pagenation)
      RSStore.fwtypeList = list
    } catch (e) {
      console.error("fwtype 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddFwtype = async (fwtypename: string) => {
    try {
      const result = await addFwtypeAPI(fwtypename)
      console.log("fwtype 추가 완료 id:", result)
    } catch (e) {
      console.error("fwtype 추가 중 에러 발생:", e)
    }
  }

  const onUpdateFwtype = async (fwtype: fwtype) => {
    try {
      const result = await updateFwtypeAPI(fwtype)
      if (result) {
      console.log("fwtype 업데이트 완료 :", fwtype)
      } else {
        console.error("fwtype 업데이트 실패 입력값 확인 필요 :", fwtype)
      }
    } catch (e) {
      console.error("fwtype 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteFwtype = async (id: number) => {
    try {
      const result = await deleteFwtypeAPI(id)
      if (result) {
        console.log("fwtype 삭제 완료 id:", id)
      } else {
        console.error("fwtype 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("fwtype 삭제 중 에러 발생:", e)
    }
  }
  
  const onPaginationFwtype = async (size: number) => {
    try {
      const totalpage = await paginationFwtypeAPI(size)
      return totalpage
    } catch (e) {
      console.error("fwtype 페이지네이션 정보를 가져오는 중 에러 발생:", e)
    }
  }
  return {
    onReadFwtypeList,
    onAddFwtype,
    onUpdateFwtype,
    onDeleteFwtype,
    onPaginationFwtype 
  }
}